import React from 'react'
import Placeholder from 'components/common/placeholder'

export const getLoadingCards = (num: number) => {
	return [...Array(num).keys()].map(i => (
		<div key={i}>
			<Placeholder style={{height: 50, margin: '10px 0 0px'}} />
		</div>
	))
}